module.exports = __webpack_public_path__ + "static/media/tree_lit.c874cf81.png";